import { titleCaseClean } from './string-utilities';

/** Maps backend status keys to user-facing badge labels; colours still use raw `status`. */
export interface StatusLabelOverride {
  from: string;
  to: string;
}

export function resolveStatusLabel(
  status: string,
  overrides: StatusLabelOverride[],
  fallbackLabel = '',
): string {
  if (!status) {
    return fallbackLabel;
  }

  const normalized = status.toUpperCase();
  const override = overrides.find(
    (entry) => entry.from.toUpperCase() === normalized,
  );

  return override?.to ?? titleCaseClean(status);
}
